window.addEventListener('load', function () {
  setTimeout(function () {
    document.querySelectorAll('header-menu').forEach(function (headerMenu) {
      const details = headerMenu.mainDetailsToggle;
      if (!details) return;

      let timer;

      details.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        details.setAttribute('open', '');
      });

      details.addEventListener('mouseleave', function () {
        timer = setTimeout(function () {
          details.removeAttribute('open');
        }, 300);
      });
    });
  }, 800);
});